import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import { Cameras } from "./camList/cameras";
import { LayoutChooser } from "./layoutChooser";
import "./streamLayout.css";

export function StreamLayout() {
  const [checked, setChecked] = React.useState(false);

  const previewHtml = checked ? (
    <iframe
      title="stream-preview"
      src="https://app.singular.live/output/7o0yAMoA9KYTr4xESDNkki/Output?bgcolor=rgb(0,0,0)&aspect=16:9"
    />
  ) : (
    <div className="border d-flex align-items-center justify-content-center">
      <p>Live View Disabled</p>
    </div>
  );

  return (
    <Container className="text-light py-4" fluid>
      <Cameras />
      <Row className="mt-4">
        <hr />
        <Col md={12} lg={6}>
          <LayoutChooser />
        </Col>
        <Col>
          <Row>
            <Col lg={9}>
              <Col className="singular-preview-frame ratio ratio-16x9">
                {previewHtml}
              </Col>
            </Col>
            <Col lg={12} className="mt-2 ms-2">
              <Form>
                <Form.Check
                  type="switch"
                  checked={checked}
                  onChange={() => setChecked(!checked)}
                  label="Enable Live View"
                />
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  );
}
